import { AxiosResponse } from "axios";
import httpUtil from "../utils/http.util";
import { IBookingRes } from "../helpers/types/global";

class BookingService {
  fetchBookings(query?: string): Promise<AxiosResponse<{ data: IBookingRes }>> {
    return httpUtil.get(`/booking/getAll${query}`);
  }
}
export default new BookingService();
